import { Controller } from '@hotwired/stimulus';
import { getAjaxModal } from 'lib/ajax-helpers';
import Cookies from 'js-cookie';
import EzUser from 'init/init-user';

export default class ApplicationController extends Controller {
  connect() {
    this.showEmailVerifiedModal();
    this.showDunningPayment();
  }

  showEmailVerifiedModal() {
    const showVerifiedModal = Cookies.get('show_email_verified_modal');

    if (showVerifiedModal === 'true') {
      Cookies.remove('show_email_verified_modal');
      // Dont reload page after survey dismissal
      Cookies.set('no_verified_survey_dismissal_reload', true);

      getAjaxModal('/render_email_verified_modal');
    }
  }

  showDunningPayment() {
    const queryString = window.location.search.slice(1);
    if (window.location.pathname !== '/' || !queryString) return;

    const params = new URLSearchParams(queryString);

    if (params.has('dunning_update_payment') && params.get('dunning_update_payment') === 'true') {
      if (EzUser.signedIn) {
        getAjaxModal('/account/billing/info-modal');
        window.history.pushState(window.history.state, '', '/');
      } else {
        getAjaxModal('/users/sign_in?dunning_update_payment=true');
      }
    }
  }
}
